import { combineEpics } from 'redux-observable';
import dashboardData from './dashboardData';

export const dashboardEpic = combineEpics(dashboardData);
